import Bacon from 'baconjs';
import * as ramda from 'ramda';

import {deserializeFields} from 'nutshell-core/entities/deserialize-fields';
import {reorder} from 'nutshell-core/list';

function toggle(topLevelEntity) {
    return function (selectedFields, toggledFields) {
        const entityFields = selectedFields[topLevelEntity];
        const fieldsToAdd = ramda.difference(toggledFields, entityFields);
        const fieldsToRemove = ramda.intersection(toggledFields, entityFields);
        const newEntityFields = ramda.difference(entityFields.concat(fieldsToAdd), fieldsToRemove);

        return ramda.mergeRight(selectedFields, {[topLevelEntity]: newEntityFields});
    };
}

function reorderEntityFields(entity) {
    return (fields, {field, newField}) => {
        const entityFields = fields[entity];
        const newFields = reorder(entityFields, field, newField);

        return {[entity]: newFields};
    };
}

export default function (dispatcher, {defaultFields, topLevelEntity}) {
    const {push, stream} = dispatcher;
    const urlStream = stream('URL').map('.query.fields');

    const selected = Bacon.update(
        {[topLevelEntity]: []},
        [urlStream],
        (unused, fields) => (fields ? deserializeFields(fields) : defaultFields),
        [stream('FIELDS-TOGGLE')],
        toggle(topLevelEntity),
        [stream('FIELDS-SET')],
        (unused, newFields) => ({[topLevelEntity]: newFields}),
        [stream('QUERY-LOAD-SAVED')],
        (unused, newQuery) => deserializeFields(newQuery.fields),
        [stream('FIELDS-RESET-TO-DEFAULT').merge(stream('QUERY-RESET-TO-DEFAULT'))],
        () => defaultFields,
        [stream('FIELDS-REORDER')],
        reorderEntityFields(topLevelEntity)
    );

    return Bacon.combineTemplate({
        selected,

        setFields(fields) {
            if (!fields.includes('name')) fields.unshift('name');
            push('FIELDS-SET', fields);
        },
        toggleFields(fields) {
            const fieldsArray = ramda.flatten([fields]);
            const fieldsOtherThanName = fieldsArray.filter((field) => field !== 'name');
            if (fieldsOtherThanName.length > 0) push('FIELDS-TOGGLE', fieldsOtherThanName);
        },
        reorderFields(field, newField) {
            push('FIELDS-REORDER', {field, newField});
        },
        resetToDefault() {
            push('FIELDS-RESET-TO-DEFAULT');
        },
    });
}
